var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"70px","height":"70px","cursor":"pointer"},attrs:{"src":require("@/assets/images/icons/excel.png")},on:{"click":_vm.makeSheetExcel}})}
var staticRenderFns = []

export { render, staticRenderFns }